import { useEffect, useState } from "react";

export const GlassCard = ({ className = "", gold = false, hover = false, children, ...p }) => (
  <div className={`v2-glass ${gold ? "v2-glass-gold" : ""} ${hover ? "v2-hover" : ""} ${className}`} {...p}>
    {children}
  </div>
);

export const Ring = ({ value = 0, size = 132, stroke = 12, children, id = "v2grad", fail = false }) => {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c - (Math.max(0, Math.min(100, value)) / 100) * c;
  return (
    <div style={{ width: size, height: size }} className="relative inline-flex items-center justify-center">
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#e3c799" />
            <stop offset="100%" stopColor={fail ? "#E0653C" : "#91cab8"} />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={`url(#${id})`} strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset .9s cubic-bezier(.2,.7,.3,1)" }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">{children}</div>
    </div>
  );
};

export const CountUp = ({ value = 0, dur = 1100, className = "" }) => {
  const [n, setN] = useState(0);
  useEffect(() => {
    let raf, start;
    const to = Number(value) || 0;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min(1, (t - start) / dur);
      setN(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value, dur]);
  return <span className={className}>{n}</span>;
};

export const Bar = ({ value = 0, className = "" }) => (
  <div className={`w-full h-2.5 rounded-full bg-white/10 overflow-hidden ${className}`}>
    <div className="h-full rounded-full" style={{ width: `${Math.max(0, Math.min(100, value))}%`, background: "linear-gradient(90deg,#91cab8,#e3c799)", transition: "width .8s cubic-bezier(.2,.7,.3,1)" }} />
  </div>
);

export const Chip = ({ children, tone = "emerald", className = "" }) => {
  const tones = {
    emerald: "text-[#91cab8] bg-[#91cab8]/12 border-[#91cab8]/25",
    gold: "text-[#e3c799] bg-[#bb9661]/12 border-[#bb9661]/30",
    muted: "text-[#bcc8cf] bg-white/5 border-white/10",
    red: "text-[#F7A08A] bg-[#B45309]/15 border-[#B45309]/30",
  };
  return <span className={`inline-flex items-center gap-1 text-xs font-bold px-3 py-1 rounded-full border ${tones[tone]} ${className}`}>{children}</span>;
};

export const Skeleton = ({ className = "" }) => <div className={`v2-skel ${className}`} />;

export const Confetti = () => {
  const colors = ["#e3c799", "#91cab8", "#bb9661", "#f6f8fa"];
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {Array.from({ length: 46 }).map((_, i) => (
        <span key={i} className="v2-confetti absolute w-2 h-3 rounded-sm"
          style={{ left: `${Math.random() * 100}%`, top: "-12px", background: colors[i % 4], animationDelay: `${Math.random() * 0.6}s` }} />
      ))}
    </div>
  );
};

export const difficulty = (points) =>
  points <= 35 ? { label: "سهل", tone: "emerald" } : points <= 55 ? { label: "متوسط", tone: "gold" } : { label: "متقدم", tone: "red" };
